import { WhatsappLogo } from "@phosphor-icons/react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About, Services, WhoWeHelp, WhyChooseUs } from "@/components/site/Sections";
import { Leadership, Testimonials } from "@/components/site/Leadership";
import { Faq, Contact, Footer } from "@/components/site/FaqContact";
import { ScrollProgress } from "@/components/site/Primitives";
import { Ribbon } from "@/components/site/Ribbon";
import { CONTACT } from "@/data/content";

export default function Landing() {
  const wa = `https://wa.me/${CONTACT.whatsapp[0]}?text=${encodeURIComponent("Hi JP Accounts, I'd like to book a free consultation.")}`;
  const openBook = () => window.open(wa, "_blank", "noopener,noreferrer");

  return (
    <div className="min-h-screen bg-cream antialiased">
      <ScrollProgress />
      <Navbar onBook={openBook} />
      <main>
        <Hero onBook={openBook} />
        <Ribbon />
        <About />
        <Services />
        <WhoWeHelp />
        <WhyChooseUs />
        <Leadership />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />

      {/* Floating WhatsApp */}
      <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center text-white hover:scale-110 transition-transform duration-300"
        aria-label="Chat on WhatsApp">
        <WhatsappLogo size={30} weight="fill" />
      </a>
    </div>
  );
}
